import React, { FC } from 'react';

import { Flex, Heading } from '@chakra-ui/react';

import { UserPill } from 'components/core/UserPill';

import { DeliveriesViewProps } from './Deliveries.props';

const DeliveriesView: FC<DeliveriesViewProps> = (props) => (
  <Flex direction="column" flex={1} color="#262626" pb={20}>
    <Flex justify="space-between">
      <Heading fontSize="24px">Deliveries</Heading>
      <UserPill />
    </Flex>
  </Flex>
);

export default DeliveriesView;
